import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { reducerPaths } from "../../../../../packages/common/src/app/reducerPaths";
import { baseQueryWithAuth } from "../../../../../packages/common/src/toolkit/methods/baseQueryWithAuth";

export const paymentsApi = createApi({
  reducerPath: reducerPaths.paymentsApi,
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    downloadBOS: builder.query({
      query: ({ Vehicle_Id }) => {
        return {
          url: `/seller/download-bos-seller/${Vehicle_Id}`,
          method: "GET",
          meta: {
            isBinary: true
          }
        }
      },
      transformResponse: (response) => {
        // This receives the raw PDF string from the baseQuery's 'text' handler
        if (typeof response === 'string' && response.startsWith('%PDF')) {
          // Convert the string into a Blob
          return new Blob([response], { type: 'application/pdf' });
        }
        // Fallback or error handling
        return response;
      },
    })
  }),
});

export const {
  useLazyDownloadBOSQuery,
} = paymentsApi;